import { Badge, IconButton, Tooltip } from '@mui/material';
import { useState } from 'react';
import { PopoverTrigger } from 'src/components/PopoverTrigger';
import { Iconify } from 'src/components/iconify';
import { useLocales } from 'src/locales';
import { MentionsPopover } from './MentionsPopover';
import { useMentionsQuery } from './useMentionsQuery';

export const UserMentions = () => {
  const [isOpened, setIsOpened] = useState<boolean>(false);
  const { unreadMentions } = useMentionsQuery();
  const { translate } = useLocales();
  return (
    <PopoverTrigger popover={MentionsPopover} isOpened={(e) => setIsOpened(e)}>
      <Tooltip
        placement="bottom"
        arrow
        title={translate('shared.labels.mentions')}
      >
        <IconButton
          color="inherit"
          sx={{
            width: 36,
            height: 36,
            borderRadius: 1,
            ...(isOpened && {
              bgcolor: (theme) => theme.palette.action.selected,
            }),
          }}
        >
          <Badge badgeContent={unreadMentions?.length} color="error">
            <Iconify icon="tabler:at" />
          </Badge>
        </IconButton>
      </Tooltip>
    </PopoverTrigger>
  );
};
